export default __webpack_public_path__ + "static/angularjs-0204ba31cfb8b8fd41040aab150b848d.svg";